export default __webpack_public_path__ + "static/pera-pdks-yazilim-programi-7ea298a425ea47ce8873562577f69813.png";